import axios from "axios";
import * as settings from "../settings";
const SESSION_DURATION = settings.SESSION_DURATION;

function AuthLogin(username, password) {
  return axios
    .post(`${settings.API_SERVER}/api/auth/login/`, {
      username: username,
      password: password,
    })
    .then((res) => {
      const token = res.data.token;
      const expirationDate = new Date(new Date().getTime() + SESSION_DURATION);
      //  do we need / expect the user id back for subsequent queries?
      localStorage.setItem("token", token);
      localStorage.setItem("expirationDate", expirationDate);
      localStorage.setItem("username", username);
      return token; // atom is updated within Login useEffect
    })
    .catch((err) => {
      console.log(err);
    });
}

const AuthLogout = () => {
  const token = localStorage.getItem("token");
  if (token === undefined) {
    localStorage.removeItem("expirationDate");
  } else {
    axios
      .post(
        `${settings.API_SERVER}/api/auth/logout/`,
        {},
        { headers: { Authorization: `Token ${token}` } }
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
    localStorage.removeItem("token");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("plan");
    localStorage.removeItem("username");
  }
  return;
};

export { AuthLogin, AuthLogout };
